export default __webpack_public_path__ + "static/media/ISMO CLASS-9 EXAM PATTERN 2026-27.b974ec37.pdf";